/**
 * transfrom html code classnames to tailwindcss classnames
 */

import { convertNodeToElement } from 'react-html-parser'
const useHtmlParserTransform = () => {
  const transformHTMLNode = (node, index) => {
    const isAccentTag = node.type === 'tag'
    if (isAccentTag) {
      if (node.attribs?.classname === 'text-purple-500') {
        node.attribs.class = node.attribs.classname
      }
      if (node.attribs?.classname === 'repetition-accent') {
        node.attribs.class = 'text-purple-500 font-bold'
      }
      if (node.attribs?.classname === 'grammar-underline') {
        node.attribs.class = 'underline'
      }
      if (node.attribs?.classname === 'grammar-strike') {
        node.attribs.class = 'line-through'
      }
      if (node.attribs?.classname === 'grammar-red') {
        node.attribs.style = 'background-color: rgba(255, 48, 81, 0.1);'
        node.attribs.class = 'inline-block text-red-500'
      }
      if (node.attribs?.classname === 'grammar-red-strike') {
        node.attribs.style = 'background-color: rgba(255, 48, 81, 0.1);'
        node.attribs.class = 'line-through decoration-red-500 inline-block text-red-500'
      }
      if (node.attribs?.classname === 'grammar-green') {
        node.attribs.style = 'background-color: rgba(60, 210, 120, 0.1);'
        node.attribs.class = 'inline-block text-green-500'
      }
      if (node.attribs?.classname === 'grammar-green-strike') {
        node.attribs.style = 'background-color: rgba(60, 210, 120, 0.1);'
        node.attribs.class = 'line-through decoration-green-500 inline-block text-green-500'
      }
      if (node.attribs?.classname === 'speechrate-accent-high') {
        node.attribs.class = 'text-red-500'
      }
      if (node.attribs?.classname === 'speechrate-accent-low') {
        node.attribs.class = 'text-blue-500'
      }
      if (node.attribs?.classname === 'runon-accent') {
        node.attribs.class = 'text-red-500'
      }
      if (node.attribs?.classname === 'runon-underline') {
        node.attribs.class = 'underline underline-offset-[2px] decoration-yellow-500 decoration-2'
      }
      if (node.attribs?.classname === 'ai-correction') {
        node.attribs.class = 'text-purple-500'
      }
      if (node.attribs?.classname === 'filler-accent') {
        node.attribs.class = 'text-purple-500'
      }
      return convertNodeToElement(node, index, transformHTMLNode)
    }
  }
  return { transformHTMLNode }
}
export default useHtmlParserTransform
